import styled, { css } from 'styled-components';
export const HeadingWrapper = styled.section `
  .csl-heading-s7 {
    font-size: 48px;
    line-height: 52px;
  }
  .csl-step-counter {
    .csl-text-s2:nth-child(2) {
      margin-left: 8px;
    }
  }

  ${({ theme }) => css `
    @media (max-width: ${theme.breakpoint_md}) {
      .csl-heading-s7 {
        font-size: 36px;
        line-height: 40px;
      }
    }
  `}
`;
export const PageHeadingWrapper = styled.div `
  #heading {
    margin-top: ${(props) => {
    if (props.styleCondition) {
        return '2.5rem';
    }
    return '0.75rem';
}};
  }
`;
//# sourceMappingURL=styles.js.map